import {
  SidebarDivider,
  ScrollSidebarTitleItem,
  flattenErrorTypeArray,
} from '@equifinance/shared';
import { useProductsContext } from '../../../contexts';
import { useTabNavHeight } from '../../AccountTabNav';
import ProductSidebarHeader from './ProductSidebarHeader';
import ProductSidebarSummary from './ProductSidebarSummary';
import { SectionSidebarItem } from '../../Sidebar/SectionSidebarItem';

export enum ProductRefNames {
  LOAN_DETAILS = 'loan-details',
  PRODUCTS = 'products',
  ESIS_HISTORY = 'esis-history',
}

export default function ProductsSidebar({ productSelected } : {productSelected: boolean}) {
  const stickyHeaderOffset = useTabNavHeight();
  const { productLoanDetails, productsObject } = useProductsContext();
  const { loanDetails, property, errors } = productLoanDetails;
  const { fees } = loanDetails ?? {};
  const {
    BrokerFee, ValuationFee, AdviceFee,
  } = fees ?? {};

  return (
    <>
      <ProductSidebarHeader />

      <SectionSidebarItem
        stickyHeaderOffset={stickyHeaderOffset}
        key="loan-details-sidebar-item"
        refName={ProductRefNames.LOAN_DETAILS}
        errors={flattenErrorTypeArray([
          ...(errors?.[loanDetails?.id] ?? []),
          ...(errors?.[property?.id] ?? []),
          ...(errors?.[BrokerFee?.id] ?? []),
          ...(errors?.[ValuationFee?.id] ?? []),
          ...(errors?.[AdviceFee?.id] ?? []),
        ])}
      >
        Loan Details
      </SectionSidebarItem>

      <SectionSidebarItem
        stickyHeaderOffset={stickyHeaderOffset}
        key="products-sidebar-item"
        refName={ProductRefNames.PRODUCTS}
        isCompleted={productSelected && !Object.entries(productsObject?.errors ?? {})?.length}
      >
        Products
      </SectionSidebarItem>

      <SidebarDivider />

      <ScrollSidebarTitleItem
        stickyHeaderOffset={stickyHeaderOffset}
        key="esis-history-sidebar-item"
        refName={ProductRefNames.ESIS_HISTORY}
      >
        ESIS History
      </ScrollSidebarTitleItem>

      <ProductSidebarSummary />
    </>
  );
}
